export const coreDomain = () =>
    process.env.NODE_ENV === "development"
        ? "https://matsuri-tech-m2m-core-manager-front-dev.vercel.app"
        : "https://core.m2msystems.cloud"

export const usersDomain = () =>
    process.env.NODE_ENV === "development"
        ? "https://matsuri-tech-m2m-users-manager-front-dev.vercel.app"
        : "https://manage-users.m2msystems.cloud"

export const isDev = () => process.env.NODE_ENV === "development"
